import { render, staticRenderFns } from "./ShippingAddForm.vue?vue&type=template&id=71ab1cd9"
import script from "./ShippingAddForm.vue?vue&type=script&lang=js"
export * from "./ShippingAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports